// extracted by mini-css-extract-plugin
export var icon = "_bg-3";
export var subtitle = "_bg-2";
export var title = "_bg-1";
export var value = "_bg-0";